import type { ReactNode } from "react";
import { TopBar } from "./TopBar";
import { LeftMenu } from "./LeftMenu";
import { BottomBar } from "./BottomBar";
import { ContentHost } from "./ContentHost";
import type { AppPageKey } from "../router/AppRouter";

interface MainLayoutProps {
  activePage: AppPageKey;
  onNavigate: (page: AppPageKey) => void;
  children: ReactNode;
}

export function MainLayout({
  activePage,
  onNavigate,
  children,
}: MainLayoutProps) {
  return (
    <div className="app-shell">
      <TopBar />
      <div className="app-body">
        <LeftMenu activePage={activePage} onNavigate={onNavigate} />
        <ContentHost>{children}</ContentHost>
      </div>
      <BottomBar />
    </div>
  );
}